import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill.js';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill.js';

export default () => (
  <SectionContainer
    id='annuity-faq-form-5498'
    backgroundVariant='lightA'
    disableBottomPadding>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'>
          Form 5498
        </Typography>
        <Accordion
          id='faq-form-5498'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          addFAQPageSchemaItemType={false}
          items={[
            {
              id: 'annuity-faq-form-5498-what-is-faq',
              title: <>What is Form 5498&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Form 5498 is an IRS form used to report contributions to IRAs, including Traditional and Roth, as well as Savings Incentive Match Plan &#40;SIMPLE&#41;
                    and Simplified Employee Pension &#40;SEP&#41;. Form 5498 is for informational purposes only and should not to be sent to the IRS along with your tax return,
                    but should be kept as part of your tax records.
                  </Typography>
                </>
              ),
            },
            {
              id: 'annuity-faq-form-5498-why-receive-faq',
              title: <>Why did I receive Form 5498&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    We send a Form 5498 if one or more of the following reportable events occurred on your retirement account during the tax year.
                  </Typography>
                  <BulletedList
                    bulletedListData={[
                      { bulletText: 'Traditional, Roth, SEP or SIMPLE IRA contribution' },
                      { bulletText: <>Re&#45;characterization</> },
                      { bulletText: '60 Day Rollover' },
                      { bulletText: 'Direct Rollover' },
                      { bulletText: 'Roth Conversion' },
                    ]}
                  />
                </>
              ),
            },
            {
              id: 'annuity-faq-form-5498-should-receive-faq',
              title: <>I have an IRA, but did not receive a Form 5498. Should I have received one&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    If no reportable events occurred on your IRA, we will report the fair market value of your account
                    to the IRS via Form 5498, but not to you. The fair market value of your IRA as of year&#45;end is provided on your December statement.
                  </Typography>
                </>
              ),
            },
            {
              id: 'annuity-faq-form-5498-why-mid-year-faq',
              title: <>Why am I receiving my Form 5498 in mid&#45;year&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Unlike traditional IRAs, contributions to SEP and SIMPLE IRAs are always reported in the year they are made &#40;calendar year&#41; per IRS regulations. The taxpayer can identify the contribution for the prior
                    year when filing the return.
                  </Typography>
                </>
              ),
            },
            {
              id: 'annuity-faq-form-5498-why-when-roll-ira-faq',
              title: <>Why did I receive Form 5498 when I rolled one IRA to another&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    IRA rollover contributions are reported to you and the IRS and confirms the portion from your prior IRA that was reinvested in another IRA.
                  </Typography>
                </>
              ),
            },
            {
              id: 'annuity-faq-form-5498-why-reflect-removed-faq',
              title: <>I made an excess contribution to my IRA, which was later removed. Why does my Form 5498 reflect the portion that was removed&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Northwestern Mutual is required to report the original contribution on Form 5498, even though it was removed as an excess distribution. The excess will be reported to the taxpayer and the IRS on Form 1099&#45;R for the year it was removed.
                  </Typography>
                </>
              ),
            },
            {
              id: 'annuity-faq-form-5498-roth-conversion-report-faq',
              title: <>How is a Roth Conversion from an IRA contribution to a Roth IRA reported&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Northwestern Mutual is required to report the original IRA contribution on Form 5498, even though your contract is now a Roth IRA. Form 1099&#45;R is used to report the amount taken from your IRA &mdash; Form 5498 reports the amount of the conversion into your Roth IRA.
                  </Typography>
                </>
              ),
            },
            {
              id: 'annuity-faq-form-5498-incorrect-information-faq',
              title: <>What should I do if I believe my Form 5498 contains incorrect information&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    You should review your records and refer to the above questions to determine if an error has occurred. If you believe an error has occurred, you should contact Northwestern Mutual as soon as possible
                    to request a corrected Form 5498.
                  </Typography>
                </>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
